import { render, staticRenderFns } from "./AppAbout.vue?vue&type=template&id=6cebd9c4&scoped=true"
import script from "./AppAbout.vue?vue&type=script&lang=js"
export * from "./AppAbout.vue?vue&type=script&lang=js"
import style0 from "./AppAbout.vue?vue&type=style&index=0&id=6cebd9c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cebd9c4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppStoreButtons: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/about/AppStoreButtons.vue').default,AboutSectionHeader: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/about/AboutSectionHeader.vue').default,AppStoreReviewBlock: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/about/AppStoreReviewBlock.vue').default,AboutCTAButton: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/about/AboutCTAButton.vue').default,FeatureCard: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/about/FeatureCard.vue').default})
